import { EKanbanCardProperty, IApplicationState, TBoardId } from '../../../../../../../../types/types';
import { createDeepEqualSelector } from '../../../../../../helpers/memoizeHelper';
import { IPreviewSetting } from '../../../components/Preview/types';
import {
    getBoardUserMetaCardPreviewHiddenProperties
} from '../../../../../../../../store/model/board/selectors/getBoardUserMetaCardPreviewHiddenProperties';
import { getBoardCards } from '../../../../../../../../store/model/selectors/getBoardCards';
import { ICard } from '../../../../../../../../store/model/card/types';
import { PREVIEW_SETTINGS_DEFAULT } from '../../../components/Preview/constants';
import { getAuthUser } from '../../../../../../../../store/model/authUser/selectors/getAuthUser';
import {
    getCardAgingIndicator
} from '../../../../../../main/kanbanView/components/Card/hocs/CardHOC/selectors/getCardAgingIndicator';

type TgetPreviewSettings = (
    state: IApplicationState,
    boardId: TBoardId,
) => IPreviewSetting[];

const getPreviewSettingsSelector = (
    properties: EKanbanCardProperty[],
    cards: ICard[],
    isAllowCardAgeing: boolean,
): IPreviewSetting[] => {
    let previewSettings = [...PREVIEW_SETTINGS_DEFAULT];
    if (!isAllowCardAgeing) {
        previewSettings = previewSettings.filter(item => item.key !== EKanbanCardProperty.AGING);
    }
    previewSettings = previewSettings.map(setting => {
        return {
            ...setting,
            value: !properties.includes(setting.key),
            cardsCount: !setting.isHideCount && cards.filter(card => setting.sortFunc(card)).length,
        };
    });
    return previewSettings as IPreviewSetting[];
};

export const getPreviewSettingsCreateSelector = (
): TgetPreviewSettings => createDeepEqualSelector(
    getBoardUserMetaCardPreviewHiddenProperties,
    (state: IApplicationState, boardId: TBoardId) => {
        const cards = getBoardCards(state, boardId);
        return cards.map((card) => {
            return {
                ...card,
                isCardAgeing: !!getCardAgingIndicator(state, card),
            };
        });
    },
    (state: IApplicationState) => getAuthUser(state).allowCardAgeing,
    getPreviewSettingsSelector,
);

export const getPreviewSettings: TgetPreviewSettings = getPreviewSettingsCreateSelector();
